export const playsmartEntry = '/ps.html'
